
export const SVGSheets = props => (
  <svg width={22} height={26} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M1 5.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C3.28 1 4.12 1 5.8 1h5.549c.978 0 1.468 0 1.928.11.408.099.798.26 1.156.48.404.247.75.593 1.441 1.285L17 4l2.125 2.125c.692.692 1.038 1.038 1.286 1.442a4 4 0 0 1 .479 1.156c.11.46.11.95.11 1.928V20.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 25 17.88 25 16.2 25H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C1 22.72 1 21.88 1 20.2z"
        fill="#458B57"
      />
      <path
        d="m21.133 8.665-.243.058m.243-.058a4.3 4.3 0 0 0-.51-1.229c-.262-.429-.628-.794-1.294-1.46l-.027-.027-2.125-2.126-1.126-1.125-.027-.027c-.666-.666-1.031-1.032-1.46-1.295a4.3 4.3 0 0 0-1.229-.509C12.846.75 12.33.75 11.387.75H5.788c-.83 0-1.468 0-1.979.042-.515.042-.922.128-1.284.312a3.25 3.25 0 0 0-1.42 1.42c-.185.363-.271.77-.313 1.285C.75 4.32.75 4.96.75 5.79v14.423c0 .83 0 1.468.042 1.979.042.515.128.922.312 1.285a3.25 3.25 0 0 0 1.42 1.42c.363.184.77.27 1.285.312.51.042 1.15.042 1.98.042h10.423c.83 0 1.468 0 1.979-.042.515-.042.922-.128 1.285-.312a3.25 3.25 0 0 0 1.42-1.42c.184-.363.27-.77.312-1.285.042-.51.042-1.15.042-1.98v-9.598c0-.942 0-1.459-.117-1.948z"
        stroke="#fff"
        strokeOpacity={0.15}
        strokeWidth={0.5}
      />
      <g filter="url(#b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m20.71 8.09-5.975-.026a1 1 0 0 1-.995-1.004l.025-5.81q.329.129.631.314c.4.244.744.586 1.43 1.268L17 3.997l2.143 2.13c.701.696 1.052 1.044 1.302 1.452q.152.246.266.511z"
          fill="#fff"
          fillOpacity={0.4}
        />
      </g>
      <path
        d="m7.6 19 2.71-3.83 2.2-3.17h1.63l-2.65 3.64L9.25 19zm4.94 0-2.24-3.36L7.65 12h1.63l2.2 3.16L14.19 19z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h22v26H0z" />
      </clipPath>
      <filter
        id="b"
        x={13.24}
        y={1.25}
        width={7.971}
        height={7.844}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_44652_69521" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_44652_69521" result="shape" />
      </filter>
    </defs>
  </svg>
)

export const SVGWord = props => (
  <svg width={22} height={26} viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M1 5.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C3.28 1 4.12 1 5.8 1h5.549c.978 0 1.468 0 1.928.11.408.099.798.26 1.156.48.404.247.75.593 1.441 1.285L17 4l2.125 2.125c.692.692 1.038 1.038 1.286 1.442a4 4 0 0 1 .479 1.156c.11.46.11.95.11 1.928V20.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 25 17.88 25 16.2 25H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C1 22.72 1 21.88 1 20.2z"
        fill="#3C6BBF"
      />
      <path
        d="m21.133 8.665-.243.058m.243-.058a4.3 4.3 0 0 0-.51-1.229c-.262-.429-.628-.794-1.294-1.46l-.027-.027-2.125-2.126-1.126-1.125-.027-.027c-.666-.666-1.031-1.032-1.46-1.295a4.3 4.3 0 0 0-1.229-.509C12.846.75 12.33.75 11.387.75H5.788c-.83 0-1.468 0-1.979.042-.515.042-.922.128-1.284.312a3.25 3.25 0 0 0-1.42 1.42c-.185.363-.271.77-.313 1.285C.75 4.32.75 4.96.75 5.79v14.423c0 .83 0 1.468.042 1.979.042.515.128.922.312 1.285a3.25 3.25 0 0 0 1.42 1.42c.363.184.77.27 1.285.312.51.042 1.15.042 1.98.042h10.423c.83 0 1.468 0 1.979-.042.515-.042.922-.128 1.285-.312a3.25 3.25 0 0 0 1.42-1.42c.184-.363.27-.77.312-1.285.042-.51.042-1.15.042-1.98v-9.598c0-.942 0-1.459-.117-1.948z"
        stroke="#fff"
        strokeOpacity={0.15}
        strokeWidth={0.5}
      />
      <g filter="url(#b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m20.71 8.09-5.975-.026a1 1 0 0 1-.995-1.004l.025-5.81q.329.129.631.314c.4.244.744.586 1.43 1.268L17 3.997l2.143 2.13c.701.696 1.052 1.044 1.302 1.452q.152.246.266.511z"
          fill="#fff"
          fillOpacity={0.4}
        />
      </g>
      <path
        d="m12.37 19 2.01-7h1.39l-2.09 7zm-4.22 0-2.07-7h1.39l1.99 7zm.18 0 1.91-7h1.24l-1.9 7zm3.91 0-1.88-7h1.24l1.95 7z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h22v26H0z" />
      </clipPath>
      <filter
        id="b"
        x={13.24}
        y={1.25}
        width={7.971}
        height={7.844}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_44652_69184" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_44652_69184" result="shape" />
      </filter>
    </defs>
  </svg>
)

export const SVGPdf = props => (
  <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_46523_51704)">
      <path
        d="M1 5.8C1 4.12 1 3.28 1.327 2.638C1.61462 2.07354 2.07354 1.61462 2.638 1.327C3.28 1 4.12 1 5.8 1H11.349C12.327 1 12.817 1 13.277 1.11C13.685 1.209 14.075 1.37 14.433 1.59C14.837 1.837 15.183 2.183 15.874 2.875L17 4L19.125 6.125C19.817 6.817 20.163 7.163 20.411 7.567C20.6303 7.92482 20.792 8.31492 20.89 8.723C21 9.183 21 9.673 21 10.651V20.2C21 21.88 21 22.72 20.673 23.362C20.3854 23.9265 19.9265 24.3854 19.362 24.673C18.72 25 17.88 25 16.2 25H5.8C4.12 25 3.28 25 2.638 24.673C2.07354 24.3854 1.61462 23.9265 1.327 23.362C1 22.72 1 21.88 1 20.2V5.8Z"
        fill="#C0293B"
      />
      <path
        d="M21.383 8.915L21.14 8.973M21.383 8.915C21.2786 8.4811 21.1065 8.06635 20.873 7.686C20.611 7.257 20.245 6.892 19.579 6.226L19.552 6.199L17.427 4.073L16.301 2.948L16.274 2.921C15.608 2.255 15.243 1.889 14.814 1.626C14.4336 1.39289 14.0188 1.22112 13.585 1.117C13.096 1 12.58 1 11.637 1H6.038C5.208 1 4.57 1 4.059 1.042C3.544 1.084 3.137 1.17 2.775 1.354C2.16363 1.66556 1.66656 2.16263 1.355 2.774C1.17 3.137 1.084 3.544 1.042 4.059C1 4.57 1 5.21 1 6.04V20.463C1 21.293 1 21.931 1.042 22.442C1.084 22.957 1.17 23.364 1.354 23.727C1.66556 24.3384 2.16263 24.8354 2.774 25.147C3.137 25.331 3.544 25.417 4.059 25.459C4.569 25.501 5.209 25.501 6.039 25.501H16.462C17.292 25.501 17.93 25.501 18.441 25.459C18.956 25.417 19.363 25.331 19.726 25.147C20.3374 24.8354 20.8344 24.3384 21.146 23.727C21.33 23.364 21.416 22.957 21.458 22.442C21.5 21.932 21.5 21.292 21.5 20.462V10.864C21.5 9.922 21.5 9.405 21.383 8.916V8.915Z"
        stroke="white"
        stroke-opacity="0.15"
        stroke-width="0.5"
      />
      <g filter="url(#filter0_d_46523_51704)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.71 8.09L14.735 8.064C14.47 8.06268 14.2163 7.95619 14.0297 7.76793C13.8431 7.57967 13.7389 7.32504 13.74 7.06L13.765 1.25C13.984 1.336 14.195 1.44 14.396 1.564C14.796 1.808 15.14 2.15 15.826 2.832L17 3.997L19.143 6.127C19.844 6.823 20.195 7.171 20.445 7.579C20.546 7.743 20.635 7.914 20.711 8.09H20.71Z"
          fill="white"
          fill-opacity="0.4"
        />
      </g>
      <path
        d="M5.032 20V15.1H6.852C7.19733 15.1 7.503 15.17 7.769 15.31C8.035 15.4453 8.24267 15.6367 8.392 15.884C8.54133 16.1267 8.616 16.409 8.616 16.731C8.616 17.0483 8.54367 17.3307 8.399 17.578C8.25433 17.8253 8.056 18.0213 7.804 18.166C7.552 18.306 7.26033 18.376 6.929 18.376H5.991V20H5.032ZM5.991 17.494H6.908C7.12267 17.494 7.29767 17.424 7.433 17.284C7.573 17.1393 7.643 16.955 7.643 16.731C7.643 16.507 7.566 16.325 7.412 16.185C7.26267 16.045 7.069 15.975 6.831 15.975H5.991V17.494ZM9.24977 20V15.1H10.8178C11.3171 15.1 11.7581 15.205 12.1408 15.415C12.5281 15.625 12.8291 15.9143 13.0438 16.283C13.2631 16.647 13.3728 17.0693 13.3728 17.55C13.3728 18.026 13.2631 18.4483 13.0438 18.817C12.8291 19.1857 12.5281 19.475 12.1408 19.685C11.7581 19.895 11.3171 20 10.8178 20H9.24977ZM10.2088 19.104H10.8178C11.0418 19.104 11.2494 19.0643 11.4408 18.985C11.6321 18.9057 11.7978 18.796 11.9378 18.656C12.0824 18.516 12.1944 18.3527 12.2738 18.166C12.3531 17.9747 12.3928 17.7693 12.3928 17.55C12.3928 17.3307 12.3531 17.1277 12.2738 16.941C12.1944 16.7497 12.0824 16.584 11.9378 16.444C11.7978 16.304 11.6321 16.1943 11.4408 16.115C11.2494 16.0357 11.0418 15.996 10.8178 15.996H10.2088V19.104ZM14.1511 20V15.1H17.2941V15.975H15.1101V17.151H16.9301V18.026H15.1101V20H14.1511Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_46523_51704"
        x="13.24"
        y="1.25"
        width="7.97095"
        height="7.84375"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46523_51704" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46523_51704" result="shape" />
      </filter>
      <clipPath id="clip0_46523_51704">
        <rect width="22" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const SVGPpt = props => (
  <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_46523_51778)">
      <path
        d="M1 5.8C1 4.12 1 3.28 1.327 2.638C1.61462 2.07354 2.07354 1.61462 2.638 1.327C3.28 1 4.12 1 5.8 1H11.349C12.327 1 12.817 1 13.277 1.11C13.685 1.209 14.075 1.37 14.433 1.59C14.837 1.837 15.183 2.183 15.874 2.875L17 4L19.125 6.125C19.817 6.817 20.163 7.163 20.411 7.567C20.6303 7.92482 20.792 8.31492 20.89 8.723C21 9.183 21 9.673 21 10.651V20.2C21 21.88 21 22.72 20.673 23.362C20.3854 23.9265 19.9265 24.3854 19.362 24.673C18.72 25 17.88 25 16.2 25H5.8C4.12 25 3.28 25 2.638 24.673C2.07354 24.3854 1.61462 23.9265 1.327 23.362C1 22.72 1 21.88 1 20.2V5.8Z"
        fill="#BD583B"
      />
      <path
        d="M21.133 8.665L20.89 8.723M21.133 8.665C21.0286 8.2311 20.8565 7.81635 20.623 7.436C20.361 7.007 19.995 6.642 19.329 5.976L19.302 5.949L17.177 3.823L16.051 2.698L16.024 2.671C15.358 2.005 14.993 1.639 14.564 1.376C14.1836 1.14289 13.7688 0.971121 13.335 0.867C12.846 0.75 12.33 0.75 11.387 0.75H5.788C4.958 0.75 4.32 0.75 3.809 0.792C3.294 0.834 2.887 0.92 2.525 1.104C1.91363 1.41556 1.41656 1.91263 1.105 2.524C0.92 2.887 0.834 3.294 0.792 3.809C0.75 4.32 0.75 4.96 0.75 5.79V20.213C0.75 21.043 0.75 21.681 0.792 22.192C0.834 22.707 0.92 23.114 1.104 23.477C1.41556 24.0884 1.91263 24.5854 2.524 24.897C2.887 25.081 3.294 25.167 3.809 25.209C4.319 25.251 4.959 25.251 5.789 25.251H16.212C17.042 25.251 17.68 25.251 18.191 25.209C18.706 25.167 19.113 25.081 19.476 24.897C20.0874 24.5854 20.5844 24.0884 20.896 23.477C21.08 23.114 21.166 22.707 21.208 22.192C21.25 21.682 21.25 21.042 21.25 20.212V10.614C21.25 9.672 21.25 9.155 21.133 8.666V8.665Z"
        stroke="white"
        stroke-opacity="0.15"
        stroke-width="0.5"
      />
      <g filter="url(#filter0_d_46523_51778)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.71 8.09L14.735 8.064C14.47 8.06268 14.2163 7.95619 14.0297 7.76793C13.8431 7.57967 13.7389 7.32504 13.74 7.06L13.765 1.25C13.984 1.336 14.195 1.44 14.396 1.564C14.796 1.808 15.14 2.15 15.826 2.832L17 3.997L19.143 6.127C19.844 6.823 20.195 7.171 20.445 7.579C20.546 7.743 20.635 7.914 20.711 8.09H20.71Z"
          fill="white"
          fill-opacity="0.4"
        />
      </g>
      <path
        d="M8.26 19V12H10.86C11.3533 12 11.79 12.1 12.17 12.3C12.55 12.4933 12.8467 12.7667 13.06 13.12C13.2733 13.4667 13.38 13.87 13.38 14.33C13.38 14.7833 13.2767 15.1867 13.07 15.54C12.8633 15.8933 12.58 16.1733 12.22 16.38C11.86 16.58 11.4433 16.68 10.97 16.68H9.63V19H8.26ZM9.63 15.42H10.94C11.2467 15.42 11.4967 15.32 11.69 15.12C11.89 14.9133 11.99 14.65 11.99 14.33C11.99 14.01 11.88 13.75 11.66 13.55C11.4467 13.35 11.17 13.25 10.83 13.25H9.63V15.42Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_46523_51778"
        x="13.24"
        y="1.25"
        width="7.97095"
        height="7.84375"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46523_51778" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46523_51778" result="shape" />
      </filter>
      <clipPath id="clip0_46523_51778">
        <rect width="22" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const SVGDefaultDoc = props => (
  <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_46535_51806)">
      <path
        d="M1 5.8C1 4.12 1 3.28 1.327 2.638C1.61462 2.07354 2.07354 1.61462 2.638 1.327C3.28 1 4.12 1 5.8 1H11.349C12.327 1 12.817 1 13.277 1.11C13.685 1.209 14.075 1.37 14.433 1.59C14.837 1.837 15.183 2.183 15.874 2.875L17 4L19.125 6.125C19.817 6.817 20.163 7.163 20.411 7.567C20.6303 7.92482 20.792 8.31492 20.89 8.723C21 9.183 21 9.673 21 10.651V20.2C21 21.88 21 22.72 20.673 23.362C20.3854 23.9265 19.9265 24.3854 19.362 24.673C18.72 25 17.88 25 16.2 25H5.8C4.12 25 3.28 25 2.638 24.673C2.07354 24.3854 1.61462 23.9265 1.327 23.362C1 22.72 1 21.88 1 20.2V5.8Z"
        fill="#707070"
      />
      <path
        d="M21.133 8.665L20.89 8.723M21.133 8.665C21.0286 8.2311 20.8565 7.81635 20.623 7.436C20.361 7.007 19.995 6.642 19.329 5.976L19.302 5.949L17.177 3.823L16.051 2.698L16.024 2.671C15.358 2.005 14.993 1.639 14.564 1.376C14.1836 1.14289 13.7688 0.971121 13.335 0.867C12.846 0.75 12.33 0.75 11.387 0.75H5.788C4.958 0.75 4.32 0.75 3.809 0.792C3.294 0.834 2.887 0.92 2.525 1.104C1.91363 1.41556 1.41656 1.91263 1.105 2.524C0.92 2.887 0.834 3.294 0.792 3.809C0.75 4.32 0.75 4.96 0.75 5.79V20.213C0.75 21.043 0.75 21.681 0.792 22.192C0.834 22.707 0.92 23.114 1.104 23.477C1.41556 24.0884 1.91263 24.5854 2.524 24.897C2.887 25.081 3.294 25.167 3.809 25.209C4.319 25.251 4.959 25.251 5.789 25.251H16.212C17.042 25.251 17.68 25.251 18.191 25.209C18.706 25.167 19.113 25.081 19.476 24.897C20.0874 24.5854 20.5844 24.0884 20.896 23.477C21.08 23.114 21.166 22.707 21.208 22.192C21.25 21.682 21.25 21.042 21.25 20.212V10.614C21.25 9.672 21.25 9.155 21.133 8.666V8.665Z"
        stroke="white"
        stroke-opacity="0.15"
        stroke-width="0.5"
      />
      <g filter="url(#filter0_d_46535_51806)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.71 8.09L14.735 8.064C14.47 8.06268 14.2163 7.95619 14.0297 7.76793C13.8431 7.57967 13.7389 7.32504 13.74 7.06L13.765 1.25C13.984 1.336 14.195 1.44 14.396 1.564C14.796 1.808 15.14 2.15 15.826 2.832L17 3.997L19.143 6.127C19.844 6.823 20.195 7.171 20.445 7.579C20.546 7.743 20.635 7.914 20.711 8.09H20.71Z"
          fill="white"
          fill-opacity="0.4"
        />
      </g>
      {props?.text && <text x="11" y="20" font-size="7" fill="white" text-anchor="middle">{props?.text}</text>}
    </g>
    <defs>
      <filter
        id="filter0_d_46535_51806"
        x="13.24"
        y="1.25"
        width="7.97095"
        height="7.84375"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_46535_51806" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_46535_51806" result="shape" />
      </filter>
      <clipPath id="clip0_46535_51806">
        <rect width="22" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
